<script setup>
defineProps({
  url: {
    type: String,
    required: true,
  },
  email: {
    type: String,
    required: true,
  },
  hide: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div class="deeplink">
    <input type="text" :value="url" />
    <span class="small-size">E-mail: {{ email }}, </span>
    <span v-if="hide" class="small-size">Hide: {{ hide }}</span>
  </div>
</template>
